// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j8NJ","rootMobile":"styles_rootMobile__1FGhr"};